export default __webpack_public_path__ + "static/media/EsKopi.c2fd2d30.png";